import { getCurrentBranding } from './branding';

// This runs immediately when the module is imported
// Initializes all branding elements: title, favicon, apple-touch-icon, and manifest
try {
    const branding = getCurrentBranding();
    document.title = branding.title;

    // Set favicon immediately
    let favicon = document.querySelector('link[rel="shortcut icon"]') ||
        document.querySelector('link[rel="icon"]');

    if (!favicon) {
        // Create favicon link element if it doesn't exist
        favicon = document.createElement('link');
        favicon.rel = 'shortcut icon';
        document.head.appendChild(favicon);
    }

    favicon.href = `${process.env.PUBLIC_URL}/${branding.favicon}`;

    // Set apple-touch-icon immediately
    let appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');

    if (!appleTouchIcon) {
        // Create apple-touch-icon link element if it doesn't exist
        appleTouchIcon = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        appleTouchIcon.sizes = '180x180';
        document.head.appendChild(appleTouchIcon);
    }

    appleTouchIcon.href = `${process.env.PUBLIC_URL}/${branding.appleTouchIcon}`;

    // Update manifest.json dynamically
    updateManifest(branding.manifest);

    // Apply CSS custom properties for nav styling
    applyCSSCustomProperties(branding.ui.navMenu.cssCustomProperties);

} catch (error) {
    console.warn('Could not set initial branding:', error.message);
    document.title = 'Loading...';
}

function updateManifest(manifestConfig) {
    // Create a blob with the dynamic manifest content
    const manifestContent = JSON.stringify(manifestConfig, null, 2);
    const blob = new Blob([manifestContent], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);

    // Update or create manifest link
    let manifestLink = document.querySelector('link[rel="manifest"]');
    if (manifestLink) {
        manifestLink.href = manifestURL;
    } else {
        manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        manifestLink.href = manifestURL;
        document.head.appendChild(manifestLink);
    }
}

function applyCSSCustomProperties(customProperties) {
    if (!customProperties) return;

    // Apply CSS custom properties to the document root
    const root = document.documentElement;
    Object.entries(customProperties).forEach(([property, value]) => {
        root.style.setProperty(property, value);
    });
}
